package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthSession
import br.com.htms.inspeccaocampo.platform.CredenciaisNavegador
import br.com.htms.inspeccaocampo.platform.UsuariosLembrados
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.foundation.background
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.ui.HtmsBackdrop
import kotlinx.coroutines.launch

@Composable
fun SharedLoginScreen(
    onLoggedIn: (AuthSession) -> Unit,
    /** Quando true, o shell (Web) já desenha backdrop + coluna; não repete o fundo. */
    embeddedInShell: Boolean = false
) {
    var lembrados by remember { mutableStateOf(UsuariosLembrados.lista()) }
    var username by remember { mutableStateOf(lembrados.firstOrNull().orEmpty()) }
    var password by remember { mutableStateOf("") }
    var lembrar by remember { mutableStateOf(true) }
    var menuUsuarios by remember { mutableStateOf(false) }
    var erro by remember { mutableStateOf<String?>(null) }
    var carregando by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()
    val focoSenha = remember { FocusRequester() }

    LaunchedEffect(Unit) {
        if (username.isNotBlank()) runCatching { focoSenha.requestFocus() }
        val salvo = runCatching { CredenciaisNavegador.obter() }.getOrNull() ?: return@LaunchedEffect
        if (password.isEmpty() && (username.isBlank() || username.equals(salvo.first, ignoreCase = true))) {
            username = salvo.first
            password = salvo.second
        }
    }

    fun tentarLogin() {
        if (carregando) return
        val u = username.trim()
        val p = password
        if (u.isBlank() || p.isBlank()) {
            erro = "Informe usuário e senha."
            return
        }
        carregando = true
        erro = null
        scope.launch {
            try {
                val result = AuthApi.login(u, p)
                result.onSuccess { session ->
                    if (lembrar) UsuariosLembrados.lembrar(u) else UsuariosLembrados.esquecer(u)
                    CredenciaisNavegador.salvar(u, p)
                    onLoggedIn(session)
                }
                    .onFailure { erro = it.message ?: "Falha no login" }
            } catch (t: Throwable) {
                erro = t.message ?: "Falha no login"
            } finally {
                carregando = false
            }
        }
    }

    val form: @Composable () -> Unit = {
        Column(
            modifier = Modifier
                .widthIn(max = 420.dp)
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(Modifier.fillMaxWidth()) {
                AppOutlinedTextField(
                    value = username,
                    onValueChange = {
                        username = it
                        erro = null
                    },
                    label = { Text("Usuário") },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth().onFocusChanged {
                        if (it.isFocused && lembrados.isNotEmpty()) menuUsuarios = true
                    },
                    enabled = !carregando,
                    trailingIcon = if (lembrados.isEmpty()) null else {
                        {
                            IconButton(onClick = { menuUsuarios = !menuUsuarios }, enabled = !carregando) {
                                Icon(Icons.Filled.ArrowDropDown, contentDescription = "Usuários salvos")
                            }
                        }
                    },
                    keyboardOptions = KeyboardOptions(
                        keyboardType = KeyboardType.Ascii,
                        imeAction = ImeAction.Next
                    ),
                    colors = FormFieldDefaults.textFieldColors()
                )
            }
            if (menuUsuarios && lembrados.isNotEmpty()) {
                Column(
                    Modifier.fillMaxWidth()
                        .background(Color.White, RoundedCornerShape(8.dp))
                        .padding(vertical = 4.dp)
                ) {
                    lembrados.forEach { u ->
                        Row(
                            Modifier.fillMaxWidth()
                                .clickable {
                                    if (!username.equals(u, ignoreCase = true)) password = ""
                                    username = u
                                    erro = null
                                    menuUsuarios = false
                                    runCatching { focoSenha.requestFocus() }
                                }
                                .padding(start = 16.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(u, modifier = Modifier.weight(1f), color = Color(0xFF1B2A41))
                            IconButton(onClick = {
                                UsuariosLembrados.esquecer(u)
                                lembrados = UsuariosLembrados.lista()
                            }) {
                                Icon(Icons.Filled.Close, contentDescription = "Esquecer $u", modifier = Modifier.size(18.dp), tint = Color(0xFF6B7280))
                            }
                        }
                    }
                }
            }
            AppOutlinedTextField(
                value = password,
                onValueChange = {
                    password = it
                    erro = null
                },
                label = { Text("Senha") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth().focusRequester(focoSenha).onFocusChanged {
                    if (it.isFocused) menuUsuarios = false
                },
                enabled = !carregando,
                visualTransformation = PasswordVisualTransformation(),
                keyboardOptions = KeyboardOptions(
                    keyboardType = KeyboardType.Password,
                    imeAction = ImeAction.Done
                ),
                keyboardActions = KeyboardActions(onDone = { tentarLogin() }),
                colors = FormFieldDefaults.textFieldColors()
            )
            Row(
                Modifier.fillMaxWidth().clickable(enabled = !carregando) { lembrar = !lembrar },
                verticalAlignment = Alignment.CenterVertically
            ) {
                Checkbox(
                    checked = lembrar,
                    onCheckedChange = { lembrar = it },
                    enabled = !carregando,
                    colors = CheckboxDefaults.colors(uncheckedColor = Color.White)
                )
                Text("Lembrar meu usuário neste aparelho", style = MaterialTheme.typography.bodyMedium, color = Color.White)
            }
            if (erro != null) {
                Text(erro!!, color = MaterialTheme.colorScheme.error)
            }
            Spacer(Modifier.height(2.dp))
            PortalButton(
                onClick = { tentarLogin() },
                enabled = !carregando,
                modifier = Modifier.fillMaxWidth()
            ) {
                if (carregando) {
                    CircularProgressIndicator(
                        modifier = Modifier.height(22.dp).padding(end = 8.dp),
                        strokeWidth = 2.dp,
                        color = Color.White
                    )
                    Text("Entrando...")
                } else {
                    Text("Entrar")
                }
            }
        }
    }

    if (embeddedInShell) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            form()
        }
        return
    }

    Box(modifier = Modifier.fillMaxSize()) {
        HtmsBackdrop(modifier = Modifier.fillMaxSize())
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            form()
        }
    }
}
